import * as React from "react"
import HomeNavBar from "../components/HomeNavBar"
import HomeHeader from "../components/HomeHeader"
import HomeAbout from "../components/HomeAbout"
import HomeWork from "../components/HomeWork"
import HomeReviews from "../components/HomeReviews"
import MarathonAbout from "../components/MarathonAbout"
import MarathonProfit from "../components/MarathonProfit"

const options = {
  rootMargin: "0px 0px",
  threshold: [0.75],
}

const HomePage = ({ imgsData, location }) => {
  const AboutRef = React.useRef(null)
  const WorkRef = React.useRef(null)
  const ReviewRef = React.useRef(null)
  const AboutMarathonRef = React.useRef(null)
  const MarathonProfitRef = React.useRef(null)
  const [isHeaderPlay, setHeaderPlay] = React.useState(false)
  const [isAboutPlay, setAboutPlay] = React.useState(false)
  const [isWorkPlay, setWorkPlay] = React.useState(false)
  const [isReviewsPlay, setReviewsPlay] = React.useState(false)
  const [isAboutMarathonPlay, setAboutMarathonPlay] = React.useState(false)
  const [isProfitPlay, setProfitPlay] = React.useState(false)

  React.useEffect(() => {
    if (location.search.startsWith("?goToWork")) {
      setTimeout(() => {
        WorkRef.current.scrollIntoView({ behavior: "smooth" })
      }, 500)
    }

    if (!IntersectionObserver) {
      setAboutPlay(true)
    }

    const header = document.getElementById("header")
    const about = document.getElementById("about")
    const work = document.getElementById("work")
    const aboutMarathon = document.getElementById("aboutMarathon")
    const profit = document.getElementById("profit")
    const rewiews = document.getElementById("rewiews")

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.target === header && !isHeaderPlay) {
            setHeaderPlay(true)
          }
          if (entry.target === about && !isAboutPlay) {
            setAboutPlay(true)
          }
          if (entry.target === work && !isWorkPlay) {
            setWorkPlay(true)
          }
          if (entry.target === aboutMarathon && !isAboutMarathonPlay) {
            setAboutMarathonPlay(true)
          }
          if (entry.target === profit && !isProfitPlay) {
            setProfitPlay(true)
          }
          if (entry.target === rewiews && !isReviewsPlay) {
            setReviewsPlay(true)
          }
        }
      })
    }, options)

    observer.observe(header)
    observer.observe(about)
    observer.observe(work)
    observer.observe(rewiews)
    observer.observe(aboutMarathon)
    observer.observe(profit)

    return () => observer.disconnect()
  }, [
    location.search,
    isHeaderPlay,
    isAboutPlay,
    isWorkPlay,
    isReviewsPlay,
    isAboutMarathonPlay,
    isProfitPlay,
  ])

  return (
    <React.Fragment>
      <HomeNavBar
        aboutRef={AboutRef}
        workRef={WorkRef}
        reviewRef={ReviewRef}
        aboutMarathonRef={AboutMarathonRef}
      />

      <HomeHeader
        workRef={WorkRef}
        isHeaderPlay={isHeaderPlay}
        imgData={imgsData.dashaHome.childImageSharp.fluid}
      />

      <MarathonAbout
        aboutMarathonRef={AboutMarathonRef}
        isAboutMarathonPlay={isAboutMarathonPlay}
      />

      <MarathonProfit
        marathonProfitRef={MarathonProfitRef}
        isProfitPlay={isProfitPlay}
      />

      <HomeWork
        workRef={WorkRef}
        reviewRef={ReviewRef}
        isWorkPlay={isWorkPlay}
      />

      <HomeAbout
        aboutRef={AboutRef}
        isAboutPlay={isAboutPlay}
        imgIcon={imgsData.authorHome.childImageSharp.fluid}
        imgBack={imgsData.authorBack.childImageSharp.fluid}
      />

      <HomeReviews reviewRef={ReviewRef} isReviewsPlay={isReviewsPlay} />
    </React.Fragment>
  )
}

export default HomePage
